export const getDayOfWeek = (dayNumber: number, country: string): string => {
  const brDays = ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado'];
  const argDays = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'];
  return country === 'BRA' ? brDays[dayNumber] : argDays[dayNumber];
}

export const parseDateWithWeek = (
  date: Date,
  weekDay: string,
  hour: number | null = null,
  minutes: number | null = null
): string => {
  if (!(date instanceof Date) || !weekDay) {
    return '';
  }
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = date.getUTCDate().toString().padStart(2, '0');
  const hourFormatted =
    hour !== null && minutes !== null
      ? `- ${hour}:${minutes.toString().padStart(2, '0')}`
      : '';
  return `${day}/${month}/${date.getFullYear()} (${weekDay}) ${hourFormatted}`;
};

export const formattedDateDefault = (date: string): string => {
  const newDate = new Date(date);
  if (isNaN(newDate.getTime())) {
    return '';
  }
  const year = newDate.getFullYear();
  const month = (newDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = newDate.getUTCDate().toString().padStart(2, '0');
  return `${day}/${month}/${year}`;
};

// Função para formatar a data yyyy-mm-dd
export const formatDateToISO = (date: Date): string => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const getMomentTimestamp = (date: Date): string => {
  const isoDate = formatDateToISO(date);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  const milliseconds = date.getMilliseconds().toString().padStart(3, '0');
  return `${isoDate}T${hours}:${minutes}:${seconds}.${milliseconds}`;
};

export const getHourFromDate = (date: string): string => {
  const newDate = new Date(date);
  if (isNaN(newDate.getTime())) {
    return '';
  }
  const hour = newDate.getHours();
  const minutes = newDate.getMinutes();
  if (isNaN(hour) || isNaN(minutes)) {
    return '';
  }
  return ` - ${formatHour(hour, minutes)}`;
};

export const formatHour = (hour: number, minutes: number): string => `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

export const getRandomScreenVersion = () => Math.floor(Math.random() * 1000);

export const getRecallPrintDate = (date: string): string => {
  const hourFormatted = getHourFromDate(date);
  const dayAndMonth = formattedDateDefault(date);
  return dayAndMonth + hourFormatted;
};
